import { useEffect, useState } from "react";

import api from "../api/client";

import { getUser } from "../store/authStore";

import {
  getSelectedClinicId,
} from "../store/selectedClinicStore";

export default function useReport(year, quarter, reportId) {

  const [report, setReport] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {

    setLoading(true);

    let url = "/api/report/";

    if (reportId) {

      url = `/api/report/${reportId}/`;

    } else {

      const params = [];

      if (year && quarter) {
        params.push(`year=${year}`);
        params.push(`quarter=${quarter}`);
      }

      const user = getUser();

      if (user?.role !== "clinic") {

        const clinicId = getSelectedClinicId();

        if (clinicId) {
          params.push(`clinic_id=${clinicId}`);
        }
      }

      if (params.length > 0) {
        url += `?${params.join("&")}`;
      }
    }
    api.get(url)
      .then((res) => setReport(res.data))
      .catch((err) => {
        console.error("Ошибка загрузки отчета:", err);
        setReport(null);
      })
      .finally(() => setLoading(false));

  }, [year, quarter, reportId]);

  return { report, loading };
}
